var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99901 1.00146V9.0003M12.9457 4.71292C13.9244 5.71981 14.5909 7.00254 14.8608 8.39894C15.1307 9.79533 14.9919 11.2427 14.4621 12.558C13.9322 13.8733 13.035 14.9975 11.8839 15.7884C10.7328 16.5793 9.37949 17.0015 7.99512 17.0015C6.61075 17.0015 5.25746 16.5793 4.10636 15.7884C2.95527 14.9975 2.05806 13.8733 1.52818 12.558C0.998302 11.2427 0.859545 9.79533 1.12946 8.39894C1.39937 7.00254 2.06583 5.71981 3.04456 4.71292",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/Power.6cf872fbabac10e2bf21ead02db9e28f.svg";
export { ForwardRef as ReactComponent };